module.exports = __webpack_public_path__ + "img/cast_logo_only.63498011.svg";